export const numberUtils = {
  onlyNumber(evt: any) {
    const numberPattern = /\d+/g;
    const keysAccepteds = [
      'Delete',
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];

    if (!numberPattern.test(evt.key) && !keysAccepteds.includes(evt.key)) {
      return evt.preventDefault();
    }
    return true;
  },
};

export function formatDecimal(value: number, locale = 'pt-BR') {
  return value.toLocaleString(locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}

/**
 * Shipping fees arrive from the backend with up to 6 decimals
 * (`Decimal.Round(CustCar / stdQuantity, 6)`). They must never be truncated to
 * two decimals — neither for display nor before being summed.
 */
export const SHIPPING_DECIMALS = 6;

export function formatFullDecimal(value: number, locale = 'pt-BR') {
  return value.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: SHIPPING_DECIMALS,
  });
}

export function formatFullCurrency(value: number, locale = 'pt-BR') {
  return value.toLocaleString(locale, {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: SHIPPING_DECIMALS,
  });
}

export const MONEY_DECIMALS = 2;

export function roundMoney(value: number) {
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Number(value.toFixed(MONEY_DECIMALS));
}

export function multiplyMoney(unitPrice: number, quantity: number) {
  return roundMoney(roundMoney(unitPrice) * quantity);
}

export function sumMoney(values: number[]) {
  return roundMoney(values.reduce((acc, value) => acc + roundMoney(value), 0));
}

export function stringToFloat(value: string) {
  if (value === undefined || value === null || value === '') {
    return 0;
  }
  return parseFloat(value.replace('.', '').replace(',', '.'));
};
